import axios from 'axios'
import { Message } from 'element-ui'
import qs from 'qs'

const baseUrl = 'https://api.xiaohudi.com/'

const instance = axios.create({
    baseURL: baseUrl,
    timeout: 60000,
    withCredentials: true
})

instance.interceptors.request.use(config => {
    try {
        let sid = localStorage.getItem('sid')
        if (sid) {
            if (config.method == "get") {
                let param = qs.parse(config.params)
                param.sid = sid
                config.params = param
            } else {
                let param = qs.parse(config.data)
                param.sid = sid
                config.data = qs.stringify(param)
            }
        }
        if (!~location.href.indexOf("login") && !sid && !~location.href.indexOf("robotManager") && !~location.href.indexOf("lotterygift")&& !~location.href.indexOf("lotteryGift")) {
            location.replace('/login')
        }
    } catch (e) {
        throw e
    }
    return config
})

instance.interceptors.response.use(
    response => {
        // 在这里你可以判断后台返回数据携带的请求码
        if (response.data.code === 0) {
            return response.data
        } else {
            if (response.config.resParams) {
                if (response.config.resParams.notify == true) {
                    // if (response.data.code === -2050) {
                    //   location.replace('/login')
                    // }
                    // if (response.data.message.length == 0) {
                    //   return;
                    // }
                    // Message({
                    //   showClose: true,
                    //   message: response.data.message,
                    //   type: 'error'
                    // })
                }
            }

            return response.data
        }
    },
    error => {
        console.log('err', error)
        // Message({
        //   showClose: true,
        //   message: '网络故障！请检查网络，或联系客服',
        //   type: 'error'
        // })
        return Promise.reject(error)
    }
)

export default {
    get(
        url,
        param,
        resParams = {
            notify: true
        }
    ) {
        return new Promise((resolve, reject) => {
            instance
                .get(url, {
                    params: param,
                    resParams: resParams
                })
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    post(
        url,
        param,
        resParams = {
            notify: true
        }
    ) {
        return new Promise((resolve, reject) => {
            instance
                .post(url, qs.stringify(param), {
                    resParams: resParams
                })
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
}